
















































































































































































































































































































































































































































































































































































































































































































































































































    import { BaseTLTableBase, Vue, Watch, Component, Prop, tlIAmountCzech, tlISODateTimeToLocalNoSecondsString, EnumsService, EnumsFilter, ObjectTypesHelper, Multiselect, Keypress } from "../../Infrastructure/CorBase/CoreBase";
	import { BIconAlignTop, BTable } from 'bootstrap-vue';
	import TagModal from "./BaseTLModalDialogTag.vue";
	import PopUpModal from "./BaseTLModalDialogPopUp.vue";
	import ModalDetail from "./BaseTLModalDialogDetail.vue";
	import BaseTLInput from "./BaseTLInput.vue";
	import BaseTLModalDialogTag from "./BaseTLModalDialogTag.vue";


    interface iBaseList {
        id: number;
        name: string;
    }

   
	@Component({
		components: {
			Keypress: () => import('vue-keypress')
		}
	})
	export default class BaseTLTable extends BaseTLTableBase {

		@Prop({ required: true }) itemsData: any; //zakladni datova napln
		@Prop({ required: true }) fields: any;  //jmena sloupců
		@Prop({ required: false }) filters: any;  //filter - seznam filtru a jejich typů

		@Prop({ required: false }) gridFields: any; //odkud co namapovat

		@Prop({ type: String, required: false, default: "" }) design?: string; //design - detail, modal (zatim neni nic)

        @Prop({ type: Boolean, required: false, default: true }) allowDoubleClick?: boolean; //voleni double click, default je true, ale kdyby to bylo potreba nekde zrusit

        @Prop({ type: Boolean, required: false, default: false }) disabled?: boolean; //disablovani cele tabulky

        @Prop({ type: Boolean, required: false, default: true }) disableAddNewAllow?: boolean; //moznost vypnout disablovani nove polozky, kdy je v seznamu vybran radek

        @Prop({ type: Boolean, required: false, default: false }) notUsePerPage?: boolean; //chci vsechny zaznamy - vypnout perPage

		//nové redesign property
		@Prop({ type: Boolean, required: false, default: true }) showAddButton?: boolean; //zobrazení nové položky (plusko)
		@Prop({ type: String, required: false, default: "baseTable.addNew" }) addButtonName?: string; //popis nove polozky pokud chceme
        @Prop({ type: Boolean, required: false, default: false }) addButtonDisable?: boolean; //disable add button
        
        @Prop({ type: String, required: false, default: 'global.buttonNewItem' }) showAddButtonTooltip?: string; //zobrazení nové položky (plusko) jeho tooltip
		 @Prop({ type: String, required: false, default: "buttonIconNovaPolozka" }) addButtonIcon?: string; //icona nove položky
		
		@Prop({ type: Boolean, required: false, default: false }) showBackButton?: boolean; //zobrazení tlacitko na navrat na predchozi stranku
		@Prop({ type: String, required: false, default: "global.buttonBack" }) showBackButtonTitle!: string; //návratové tlačítko název
		@Prop({ type: String, required: false, default: "global.buttonBackTooltip" }) showBackButtonTooltip?: string; //návratové tlačítko tooltip
		@Prop({ type: Boolean, required: false, default: false }) showBackButton2?: boolean; //2. zobrazení tlacitko na navrat na predchozi stranku
        @Prop({ type: Boolean, required: false, default: false }) showBackButton3?: boolean; //3. zobrazení tlacitko na navrat na predchozi stranku
        @Prop({ type: String, required: false, default: "global.buttonBack" }) showBackButtonTitle2!: string; //2. návratové tlačítko název
		@Prop({ type: String, required: false, default: "global.buttonBackTooltip" }) showBackButtonTooltip2?: string; //2. návratové tlačítko tooltip
        @Prop({ type: String, required: false, default: "global.buttonBack" }) showBackButtonTitle3!: string; //3. návratové tlačítko název
        @Prop({ type: String, required: false, default: "global.buttonBackTooltip" }) showBackButtonTooltip3?: string; //3. návratové tlačítko tooltip
        @Prop({ type: String, required: false, default: "" }) infoRightText!: string; //doplnkovy text v pravo

		@Prop({ type: String, required: false, default: "" }) description?: string; //název - TODO dat to povinne
		@Prop({ type: String, required: false, default: "" }) description2?: string; //název - ten umistovat dole
        @Prop({ type: String, required: false, default: "" }) descriptionNumber?: string; //název - TODO dat to povinne
		@Prop({ type: String, required: true, default: "" }) name?: string; //jednoznačny identifator - podle ktereho ukládá stav
		@Prop({ type: Boolean, required: false, default: false }) allowGrid?: boolean; //je možnost přepnout na grid

		@Prop({ type: Boolean, required: false, default: false }) showInModal?: boolean; //zobrazuje se v modalnim okne, pribýva zaviraci ikona
        @Prop({ type: Boolean, required: false, default: false }) notChangeUrl?: boolean; //nemeni se url filtry, kdyz je tabulka soucasti napr. detailu

		@Prop({ type: Boolean, required: false, default: false }) selected?: boolean; //možnost vybrat , potřeba dodat
		@Prop({ type: Boolean, required: false, default: false }) selectedMultiHelp?: boolean; //zobrazi se i seznam vsech vybranych, ktery jde odklikavat
		@Prop({ type: Array, required: false }) selectedMultiNames!: string[]; //když je selectedMultiHelp je potreba popsat z ceho se budou skladat ten vyber napr,  { "idPersonNavigationLastname", "idPersonNavigationFirstname" }

		@Prop({ type: Boolean, required: false, default: true }) filterSearch?: boolean; //filter viditelnost - vyhledávání
		@Prop({ type: Boolean, required: false, default: true }) filterSearchOn?: boolean; //filter viditelnost - filter podle skupin
		@Prop({ type: Boolean, required: false, default: true }) filterPerPage?: boolean; //filter viditelnost - kolik stránek
		@Prop({ type: Boolean, required: false, default: true }) filterPagination?: boolean; //filter viditelnost - strankovani

        @Prop({ type: String, required: false, default: ""}) buttonDetailName?: string; //vlastní pojmenování tlačítka info
		@Prop({ type: String, required: false, default: "buttonDetail" }) buttonDetailClass?: string; //vlastní tlačítka css class detailu
		@Prop({ type: Boolean, required: false, default: false }) buttonDetail?: boolean; //button action - info tlačitko
		@Prop({ type: String, required: false, default: "ÚpravaObs" }) buttonUpdateName?: string; //vlastní pojmenování tlačítka úprava
		@Prop({ type: Boolean, required: false, default: false }) buttonUpdate?: boolean; //button action - update tlačitko
		@Prop({ type: Boolean, required: false, default: false }) buttonDelete?: boolean; //button action - delete tlačitko
        @Prop({ type: String, required: false, default: "" }) buttonDeleteName?: string; //vlastní pojmenování tlačítka smazat
		@Prop({ type: Boolean, required: false, default: false }) buttonOther?: boolean; //button action - vlastni tlacitko
        @Prop({ type: String, required: false, default: "global.buttonPrintTooltip" }) buttonOtherName?: string; //vlastní pojmenování tlačítka
		@Prop({ type: String, required: false, default: '' }) buttonOtherParam?: string; //button action - vlastni tlacitko - parametry ktery musi splnit aby bylo viditelne
		@Prop({ type: String, required: false, default: "buttonAdd" }) buttonOtherClass?: string; //vlastní tlačítka css class
			

		@Prop({ type: Boolean, required: false, default: false }) buttonOther2?: boolean; //button action - vlastni tlacitko 2
		@Prop({ type: String, required: false, default: "Other2" }) buttonOtherName2?: string; //vlastní pojmenování tlačítka 2
		@Prop({ type: String, required: false, default: "buttonOther2" }) buttonOtherClass2?: string; //vlastní tlačítka css class, druhe
		@Prop({ type: Boolean, required: false, default: false }) buttonOther3?: boolean; //button action - vlastni tlacitko 3
		@Prop({ type: String, required: false, default: "Other3" }) buttonOtherName3?: string; //vlastní pojmenování tlačítka 3
		@Prop({ type: String, required: false, default: "buttonOther3" }) buttonOtherClass3?: string; //vlastní tlačítka css class, treti
		@Prop({ type: Boolean, required: false, default: false }) buttonOther4?: boolean; //button action - vlastni tlacitko 4
		@Prop({ type: String, required: false, default: "Other4" }) buttonOtherName4?: string; //vlastní pojmenování tlačítka 4
		@Prop({ type: String, required: false, default: "buttonOther4" }) buttonOtherClass4?: string; //vlastní tlačítka css class, ctvrty

		@Prop({ type: Boolean, required: false, default: false }) simpleTable?: boolean; //schování stránkování

		@Prop({ type: Array, required: false }) dropDownList!: any[]; //obsah drop down listu

        @Prop({ type: String, required: false, default: "" }) moreActionIcon?: string; //jaka ma byt pouzita ikona u tlacitka
        @Prop({ type: String, required: false, default: "" }) moreActionIcon2?: string; //jaka ma byt pouzita ikona u tlacitka2
		@Prop({ type: String, required: false, default: "" }) moreActionIcon3?: string; //jaka ma byt pouzita ikona u tlacitka3

		@Prop({ type: String, required: false, default: "" }) moreActionIconVariant?: string; //jaka ma byt pouzita varianta green, red
		@Prop({ type: String, required: false, default: "" }) moreActionIconVariant2?: string; //jaka ma byt pouzita varianta green, red
        @Prop({ type: String, required: false, default: "" }) moreActionIconVariant3?: string; //jaka ma byt pouzita varianta green, red

		@Prop({ type: String, required: false, default: "" }) moreActionTitle?: string; //nazev pro hromadnou akci
		@Prop({ type: String, required: false, default: "" }) moreActionTitle2?: string; //nazev pro hromadnou akci 2
		@Prop({ type: String, required: false, default: "" }) moreActionTitle3?: string; //nazev pro hromadnou akci 3

		@Prop({ type: Boolean, required: false, default: true }) moreActionAllow1?: boolean; //enabale/disable hromadne akce
		@Prop({ type: Boolean, required: false, default: true }) moreActionAllow2?: boolean; //enabale/disable hromadne akce
		@Prop({ type: Boolean, required: false, default: true }) moreActionAllow3?: boolean; //enabale/disable hromadne akce

        @Prop({ type: Boolean, required: false, default: true }) moreActionShow?: boolean; //zobrazeni hromadne akce
        @Prop({ type: Boolean, required: false, default: true }) moreActionShow2?: boolean; //zobrazeni hromadne akce
        @Prop({ type: Boolean, required: false, default: true }) moreActionShow3?: boolean; //zobrazeni hromadne akce
        @Prop({ type: Boolean, required: false, default: true }) moreActionShow4?: boolean; //zobrazeni hromadne akce

        @Prop({ type: String, required: false, default: "" }) moreActionTooltip?: string; //napoveda k akci
        @Prop({ type: String, required: false, default: "" }) moreActionTooltip2?: string; //napoveda k akci 2
        @Prop({ type: String, required: false, default: "" }) moreActionTooltip3?: string; //napoveda k akci 3

        @Prop({ type: Boolean, required: false, default: false }) moreActionAllow1Objects?: boolean; //posilani celych objektu, misto IDcek, pro specialni pripady
		@Prop({ type: String, required: false, default: "" }) defaultSortBy?: string; //sortBy
        @Prop({ type: Boolean, required: false, default: false }) defaultSortDesc?: boolean; //sort desc
		//TODO proč musím použít v LoginHistoryList???
		@Prop({ type: Boolean, required: false, default: true }) isBusyShow?: boolean; //zobrazení spinneru - někde je potřeba použit po fetchi
		@Prop({ type: Boolean, required: false, default: false }) useTagModal?: boolean; //zapnutí možnosti tagů
        @Prop({ type: String, required: false, default: "receiver" }) typeTagModal!: string; // k čemu se bude ukladat tagy 1)content - media 2) taks - ulohy 3) default receiver -zařízení

        
		@Prop({ type: Number, required: false, default: ObjectTypesHelper.ObjectTypeEnum.Content }) objectType?: ObjectTypesHelper.ObjectTypeEnum;
		@Prop({ type: Boolean, required: false, default: true }) fixedMenu?: boolean; //menu zustava stale nahore, nescroluje
		@Prop({ type: Boolean, required: false, default: false }) onlyOne?: boolean; //vyber pouze jednoho prvku


        @Prop({ type: String, required: false, default: "" }) bottomAddActionTitle?: string; //nazev pro pridani v tabulce   - pro pridani v tabulce 
        @Prop({ type: Boolean, required: false, default: true }) bottomAddActionShow?: boolean; //zobrazeni pro pridani v tabulce  -pro pridani v tabulce 
        @Prop({ type: String, required: false, default: "" }) bottomAddActionIconVariant?: string; //jaka ma byt pouzita varianta green, red  - pro pridani v tabulce 
        @Prop({ type: String, required: false, default: "" }) bottomAddActionIcon?: string; //jaka ma byt pouzita ikona u tlacitka  - pro pridani v tabulce 
        @Prop({ type: Boolean, required: false, default: true }) bottomAddActionAllow?: boolean; //povoleni hromadne akce  - pro pridani v tabulce 
        @Prop({ type: String, required: false, default: "" }) bottomAddActionTooltip?: string; //tooltip   - - pro pridani v tabulce 

		deleteClick(id: number) {
			this.actionDeleteId(id);
		}

		disabledAddNew() {
         
			return (this.disableAddNewAllow && this.selectedItemsMain.length > 0) || this.addButtonDisable;
		}

		addNewVariant() {
			return this.disableAddNewAllow && this.selectedItemsMain.length > 0 ? "" : "green";
		}

		buttonDetailNameTooltip() {
			return this.buttonDetailName == "" ? this.$t('global.buttonDetailTooltip').toString() : this.buttonDetailName;
		}

		buttonDeleteNameTooltip() {
            return this.buttonDeleteName == "" ? this.$t('global.buttonDeleteTooltip').toString() : this.buttonDeleteName;
        }

		isBold(data:any) {
            return data.item == null ? '' : (data.item.isBold == true ? 'rowFontBold': '');
		}

		countItems = 0;
		descriptionPrepare() {
			if (this.simpleTable == true && this.descriptionNumber !="") {
                return this.description + " (" + this.descriptionNumber + ")";
			}
			else {
				return this.description;
			}
		}


		scrollTable(event: any) {
            this.scrollBarInDown = event.target.scrollTop + 10 + event.target.clientHeight >event.target.scrollHeight;      
		}








        sortCompareOptions: Intl.CollatorOptions = {
            numeric: false,
            sensitivity: 'case',
            caseFirst: 'upper'
        };

        filterItemsBefore() {
            if (this.countNextPage == 1) {
                return this.filterItems();
            } else { // tady kdyz pridame dalsich x zaznamu na stranku
                var from = (this.oldCurrentPage - 1) * this.perPage;
				var result = (this.filterItems() as Array<any>);
				debugger;
                result.sort((a: any, b: any) => {
                    // Zkontrolujeme, jestli jsou porovnávané hodnoty null nebo undefined
                    let aValue = a[this.sortBy];
                    let bValue = b[this.sortBy];

                    if (aValue === null || aValue === undefined) {
                        return this.sortDesc ? -1 : 1; // Posuneme a na konec nebo začátek
                    }
                    if (bValue === null || bValue === undefined) {
                        return this.sortDesc ? 1 : -1; // Posuneme b na konec nebo začátek
                    }

                    // Provedeme standardní porovnání, pokud nejsou hodnoty null/undefined
                    const comparison = aValue.localeCompare(bValue, undefined, this.sortCompareOptions);
                    return this.sortDesc ? -comparison : comparison;
                });

                var result = result.slice(from);
                return result;
            }
        }


		
		getPerPage() {
            if (this.countNextPage>1) {
				var hodnota = this.perPage * this.countNextPage;
				return hodnota; 
			}
			else {
				return this.notUsePerPage == true ? 10000 : this.perPage;
			}
        }

		//tridy pouze pro modalni dialog, tak potrebuji postupne zvetseni velikosti kvuli dvojkliku
		showClass(mainClass: string, addClass: string){
			var addClass = this.showInModal ? addClass : "";
			 return mainClass + " " + addClass; 
		}


		getCountColumn() {
            return String(this.fieldsItems().length);
		}

		mounted() {
			window.addEventListener('resize', () => {
				this.setHeightTableNextTick();
               
			});			
            this.setModalTag();
			this.setHeightTableNextTick();

			//POZOR nelze primo pouzit super.promena z predka !!!!!!!!!!!!  je treba to delat pres metodu
			if (this.showInModal) {
				this.setShowInModalBase();
			}
			if (this.notChangeUrl) {
                this.setNotChangeUrlBase();
			}
		}

		selectedItemsText() {
			return this.$t('baseTable.selectedItems').toString() + this.selectedItemsMain.length + ".";
		}

		selectedItemsAllText() {
			return this.$t('baseTable.selectedItemsIsAll').toString().replace("0", this.totalRows.toString());
		}
        selectedItemsAllTextClick() {
            return this.$t('baseTable.selectedItemsAll').toString().replace("0", this.totalRows.toString());
        }

		isSortable(data: any) {
			if (data.column == "selected") {
				return false;
			}
       

            return data.field['sortable'] == true
		}

		classHead() {
            return this.simpleTable == true ? "settingColumnHeadSimple" : "settingColumnHead";
		}

		classFilterColumn() {
			//TODO PUVODNI
			//var result = "minWidth300 settingColumnMenu minWidth300 ";
			var result = "";
            result += this.design == 'detail' ? " helpPositionAbsoluteX " : "";

			return result;
        }

		formatAmountClass(data: any) {
            return data.value < 0 ? "amountColumnMinus" : "amountColumnPlus";
		}

		formatAmout(data: any) {
            return tlIAmountCzech(data.value);
        }

		updated() {
			super.afterUpdate();
        }

		//vyska tabulky - se dynamicky dopocitava
		//heightTable = "200px";
		setHeightTable(): void {
			var filterBlock = document.getElementById("idFilterSelected");
			var heightFilter = 0;
			if (filterBlock != null) {
				heightFilter = filterBlock.offsetHeight;
			}
			//dynamicky vypocet tabulky
			//var height = window.innerHeight - 170 - 60 - 30 - heightFilter;
			var heightGrid = this.isGridShow ? 20 : 0;
			var height = window.innerHeight - 170 - heightGrid - heightFilter;
			if (height < 250) {
				height = 250;
			}
			this.heightTable = (height-10) + "px";
		}

		setHeightTableNextTick(): void {
			this.$nextTick(() => {
				this.setHeightTable();
			});
		}

		menuFixed(): string {
			return this.fixedMenu ? "menuFixedTable" : "";
		}

		closeModal() {
            this.$emit('closeModal', true);
		}

		closeSettings() {
			//kdyz je spusten modalni dialog nechci aby se zavrelo i nastaveni
			if ((this.$refs.tagModal as TagModal).isVisible() == false) {
				this.showFilterSetting = this.showColumnSetting = false;
                this.$emit('changeShowMenu', false);            
			}
		}


		 showBackButtonTitleCalc(): string {		
			return this.showBackButtonTitle;
		}

        showBackButtonTitleCalc2(): string {
            return this.showBackButtonTitle2;
		}

        showBackButtonTitleCalc3(): string {
            return this.showBackButtonTitle3;
        }

		get isContentObjectType(): boolean {
			return ObjectTypesHelper.isContentObjectType(this.objectType);
		}

		get isTaskPartObjectType(): boolean {
			return ObjectTypesHelper.isTaskPartObjectType(this.objectType);
		}

		get isReceiverObjectType(): boolean {
			return ObjectTypesHelper.isReceiverObjectType(this.objectType);
		}

		showButtonOther(item: any): boolean {
			var param = true;
			if (this.buttonOtherParam != '') {
				param = item['isWaitingForAcceptProvisioning'] || false;
			}
			if (this.buttonOtherParam == "allowDelete") {
                param = item['allowDelete'] || false;
			}
            if (this.buttonOtherParam == "showOtherButton") {
                param = item['showOtherButton'] || false;
            }

			return this.buttonOther! && param;
		}

		//TODO udelat lepe - na dvou mistech
		prepareIdBasePreview(data: any) {
			if (data == null) {
				return 0;
			}
			return data;
		}

		getPreviewId(id: number | null | undefined): string {
			if (id && id > 0) {
				if (this.isContentObjectType) {
					return `image_table_content_${id}`;
				}
				// TaskPart zobrazuje nahled na obrazek, ale id musi brat z jineho pole, nicmene ostatni veci vcetne cachovani jsou stejne
				if (this.isTaskPartObjectType) {
					return `image_table_content_${id}`;
				}
				if (this.isReceiverObjectType) {
					return `image_table_receiver_${id}`;
				}
			}
			return `image_popup_0`;
		}

		//zobrazeni listy s vybranymi filry
		showSelectedFilterBlock(): boolean {
			return (this.filterData as Array<any>).filter(c => (c.selected && !c.isNegative) || (!c.selected && c.isNegative) || (c.selected && c.useEnum)).length > 0 || this.showBackButton == true;
		}

		//tady tohle podbarví vybraný řádek
		rowClassSelected(item: any): string {
			if (item != undefined && this.selectedRowMain.indexOf(item.id) > -1) {
				return 'tableRowSelected';
			}
			else {
				return '';
			}
		}

		//showColumnSettings() {	
		//	this.showColumnSetting = !this.showColumnSetting;
		//	this.showFilterSetting = false;
  //          this.$emit('changeShowMenu', this.showColumnSetting); 
		//}

		//showFilterSettings() {
		//	this.showFilterSetting = !this.showFilterSetting;
		//	this.showColumnSetting = false;
  //          this.$emit('changeShowMenu', this.showFilterSetting); 
		//}
		//showFilterOrColumng(): boolean {
		//	return this.showColumnSetting || this.showFilterSetting;
		//}

		closeWindow(): void {
			this.$emit('close', true);
		}

		//prepareFilterSelected(item: any): string {
		//	if (item.type == 'datetime') {
		//		return tlISODateTimeToLocalNoSecondsString(item.value);
		//	}
		//	else {
		//		if (item.useOwnEnumsSend) { //vlastni kolekce ve filtru
		//			var sel = (item.useOwnEnumsSendArray as Array<any>).filter((c: any) => c.value == item.value);
		//			return sel.length > 0 ? sel[0].text : '';
		//		}
		//		else {
		//			return item.value;
		//		}
		//	}
		//}

		////popisek do vybranych filtru co se zobrazuji nahore
		//prepareFilterDescription(item: any): string {
		//	if (item.useOwnEnumsSend) { //vlastni kolekce ve filtru
		//		var sel = (item.useOwnEnumsSendArray as Array<any>).filter((c: any) => c.value == item.value);
		//		return sel.length > 0 ? sel[0].description : '';
		//	}
		//	else {
		//		return '';
		//	}
		//}

		getSelectedFilters() {		
			return (this.filters).filter((c: any) => c.selected && !c.group == true && c.type != 'multi');
		}

		getSelectedMultiFilters() {
			return (this.filters).filter((c: any) => c.selected && !c.group == true && c.type == 'multi');
		}

		//getSelectedGroupFilters() {
  //		return this.getFiltersByGroups();
		//}

		removeNegativeFilter(id: any): void {
			var filter = this.filters.filter((c: any) => c.key == id)[0];
			filter.selected = true;
		}

		//clearInputFilter(filter: any): void {
		//	if (filter.type == 'datetime') {
		//		var actDate = new Date();
		//		filter.value = filter.moreThan ? new Date(actDate.getFullYear(), actDate.getMonth(), actDate.getDate(), 0, 0) :
		//			new Date(actDate.getFullYear(), actDate.getMonth(), actDate.getDate(), 23, 59);
		//	}
		//	else {
		//		filter.value = '';
		//	}
		//}

		disabledRemoveFilter(): boolean {
			if (this.filters.filter((c: any) => c.default != undefined).length > 0) {
				return this.filters.filter((c: any) => c.selected).length == 1;
			}
			else {
				return false;
			}
		}

		private filterLabelClick(item: any, isGroup: boolean): void {
			if (isGroup) {
				var fil = this.filters.filter((c: any) => c.groupId == item.groupId && c.key != item.key) as Array<any>;
				var allIsFalse = fil.some((c: any) => c.selected);
				for (var i = 0; i < fil.length; i++) {
                    fil[i].selected = !allIsFalse;
				}
				this.filters.filter((c: any) => c.groupId == item.groupId && c.key == item.key)[0].selected = true;
			}
			else {
				this.filters.filter((c: any) => c.key == item.key)[0].selected = !this.filters.filter((c: any) => c.key == item.key)[0].selected;
				var filter = this.filters.filter((c: any) => c.key == item.key)[0];				
                if (filter.selected) {
                    let id = filter!.key + 'FilterInput';
                    //multi select nedělám focus....
                    if (filter.multiselect == undefined) {
                        this.$nextTick(() => {
                            document.getElementById(id)!.focus();
                        })
                    }
                }
			}
		}

		removeFilterMulti(id: any,items: any) {
            this.removeMultiFilter(id.id,items.key,items.value);
		}

		removeFilter(id: any): void {
			var filter = this.filters.filter((c: any) => c.key == id)[0];
			if (filter.showOnlyClean != true) {			
                filter.selected = filter.default != undefined ? true : false;
			}
			//TODO funguje pro vsechny typy filtru chce to proverit
			if (filter.group == undefined) {
				if (filter.type == 'datetime') {
					var actDate = new Date();
					filter.value = filter.moreThan ? new Date(actDate.getFullYear(), actDate.getMonth(), actDate.getDate(), 0, 0) :
						new Date(actDate.getFullYear(), actDate.getMonth(), actDate.getDate(), 23, 59);
				}
				else {					
					//nezrusitelny filtr nastavit zpet...nechci
					if (filter.default != undefined) {
						filter.value = filter.default;
					}
					else {
						filter.value = '';
					}
				}
			}
		}

		//TODO jak lepe volat prvek  this.$refs.tags
		removeMultiFilter(id: any, key: any, filters: any): void {
			var tagFilter = this.filterData.filter((c: any) => c.key == key)[0];
			tagFilter.value = tagFilter.value.filter((c: any) => c.id != id);
			if (tagFilter.value.length == 0) {
				tagFilter.selected = false;
			}
			
			(this.$refs.tags as Array<any>)[0].clearMulti(id);
			if ((filters as Array<any>).length < 1) {
				var filter = this.filters.filter((c: any) => c.key == key)[0];
				filter.selected = false;
			}
		}

		protected resetAllFilters(): void {
			for (var i = 0; i < (this.filters as Array<any>).length; i++) {

				if (this.filters[i].type == 'multi') {
					(this.$refs.tags as Array<any>)[0].clearMultiAll();
					this.filters[i].value = '';
					this.filters[i].selected = false;
				}
				else if (this.filters[i].default != undefined) {
					//this.filters[i].value = this.filters[i].default;
				}
				else if (this.filters[i].group == undefined) {
					if (this.filters[i].showOnlyClean != true) {
						this.filters[i].selected = false;
					}
					this.clearInputFilter(this.filters[i]);
				}
				else {
					this.filters[i].selected = this.filters[i].isNegative ? true : false;
				}
			}
			this.setHeightTableNextTick();
		}

		//TODO je to správná cesta??? nezpomaluje to??
		designType(typ: any, name: string) {
			if (name == '' && typ.field['design'] == undefined) {
				return true;
			}
			else if (typ.field['design'] == name) {
				return true;
			}
			else {
				return false;
			}
		}


		//TODO je to správná cesta??? nezpomaluje to??
		designTypeNotNull(typ: any, name: string) {
			var result = this.designType(typ, name);
			if (result) {
				if (typ.value == '') {
					return false;
				}
			}
			return result
		}


		//select z gridu
		selectItemGrid(id: number): void {
			this.clickRow(id, false);
		}

		getItemsForGrid() {
			var allItems = this.filterItems();

			let result = [];
			let start = (this.currentPage - 1) * this.perPage;
			for (var i = start; i < allItems.length; i++) {
				result.push(allItems[i]);
				if (result.length == this.perPage) {
					break;
				}
			}
			return result;
		}

		moreAction() {
			if (this.moreActionAllow1Objects) {
                this.$emit('moreAction', this.selectedItemsMain);
			}
			else {
				this.$emit('moreAction', this.selectedRowMain);
			}
			//VaPTODO - zde je problem, ze pokud se zobrazi nejaky dialog na potvrzeni akce a uzivatel klikne na ne, tak se mu i tak odznaci zaznamy,
			//        - takze je potreba jeste dodelat, at se tak stane pouze kdyz da ano, pokud se zobrazi dialog nebo jina vec, ktera tuto akci zastavi a tim padem neni duvod zrusit oznaceni radku
			//        - stejne tak by bylo dobre, aby se odznaceni udelalo az po vykonani akce, ted se to stane hned a kdyz se napr. zobrazi dialog, tak uzivatel nevidi oznacene zaznamy
			//if (this.moreActionUnselectItems) {
			//	this.selectedRowMain = [];
			//}
		}

		moreAction2() {
			this.$emit('moreAction2', this.selectedRowMain);
			//VaPTODO - zde je problem, ze pokud se zobrazi nejaky dialog na potvrzeni akce a uzivatel klikne na ne, tak se mu i tak odznaci zaznamy,
			//        - takze je potreba jeste dodelat, at se tak stane pouze kdyz da ano, pokud se zobrazi dialog nebo jina vec, ktera tuto akci zastavi a tim padem neni duvod zrusit oznaceni radku
			//        - stejne tak by bylo dobre, aby se odznaceni udelalo az po vykonani akce, ted se to stane hned a kdyz se napr. zobrazi dialog, tak uzivatel nevidi oznacene zaznamy
			//if (this.moreActionUnselectItems2) {
			//	this.selectedRowMain = [];
			//}
		}

		moreAction3() {
			this.$emit('moreAction3', this.selectedRowMain);
			//VaPTODO - zde je problem, ze pokud se zobrazi nejaky dialog na potvrzeni akce a uzivatel klikne na ne, tak se mu i tak odznaci zaznamy,
			//        - takze je potreba jeste dodelat, at se tak stane pouze kdyz da ano, pokud se zobrazi dialog nebo jina vec, ktera tuto akci zastavi a tim padem neni duvod zrusit oznaceni radku
			//        - stejne tak by bylo dobre, aby se odznaceni udelalo az po vykonani akce, ted se to stane hned a kdyz se napr. zobrazi dialog, tak uzivatel nevidi oznacene zaznamy
			//if (this.moreActionUnselectItems3) {
			//	this.selectedRowMain = [];
			//}
		}

		//hack aby nedoslo k dvojimu zavolani...
		lastCheck = '';
		changeClick(id: any, checked: any) {
			let newChecked = id + checked;
			if (this.lastCheck != newChecked) {
				this.lastCheck = newChecked;
				this.$emit('changeCheck', id);
			}
		}
		lastCheck2 = '';
		changeClick2(id: any, checked: any) {
			let newChecked = id + checked;
			if (this.lastCheck2 != newChecked) {
				this.lastCheck2 = newChecked;
				this.$emit('changeCheck2', id);
			}
		}

		addNew() {			
			this.$emit('addNew');
		}

		addButtonClick(id: any) {
			this.$emit('addButtonClick', id);
		}

		changeDropDownList(item: any, clickEvent: any, idRow: any) {
			item = clickEvent;
			this.$emit('changeDropDownList', { idCar: clickEvent, id: idRow });
		}

		//nastavení ikony podle W- wait, S - success, E- error
		showIconBy(item: any, position: number, type: string): boolean {
			return item[position] == type;
		}

		isTranscoded(data: any) {
			return data.item.isTranscoded;
		}

		showToolTipIcon(data: any) {
			let result = false;
			let findInToolTip = this.tooltipsColumns.find(c => c.text == data.field.key);
			if (findInToolTip != undefined) {
				let minLength: number = 2;
				let fields: any[] = this.fields.filter((c: any) => c.key == data.field.key);
				if (fields.length > 0) {
					let minLengthFromDefinition = fields[0].minLengthToShowTooltip as number;
					if (minLengthFromDefinition != undefined) {
						minLength = minLengthFromDefinition;
					}
				}
				Object.keys(data.item).forEach(key => {
					if (key == findInToolTip.value) {
						result = ((data.item[key] as string).split('<br/>')).length > minLength;
					}
				});
			}
			return result;
		}

		tooltipIcon(data: any) {
			var result = '';
			var findInToolTip = this.tooltipsColumns.find(c => c.text == data.field.key);
			if (findInToolTip != undefined) {

				Object.keys(data.item).forEach(key => {
					if (key == findInToolTip.value) {
						result = data.item[key];
					}
				});
			}
			return result;
		}

        tooltipIconList(data: any) {
            var result = '';
			var findInToolTip = this.tooltipsColumns.find(c => c.text == data.field.key);
            if (findInToolTip != undefined) {
                Object.keys(data.item).forEach(key => {
					if (key == findInToolTip.value) {
                        var list = data.item[key] as Array<iBaseList>;
                        for (var i = 0; i < list.length; i++) {
							result += list[i].name + " <br/>"; 
						}
                    }
                });
			}
            return result;
        }

		getFilters() {
			var allowFilter = [];
			if (this.filters != null) {
				var filtersNotGroup = (this.filters as Array<any>).filter(c => (c.group == false || c.group == undefined) && c.default == undefined);
				for (var i = 0; i < filtersNotGroup.length; i++) {
					//filtr i pro skryty sloupec - specialka
					if (filtersNotGroup[i].showAnyTime) {
						allowFilter.push(filtersNotGroup[i]);
					}
					else if (this.fields.filter((c: any) => c.key == filtersNotGroup[i].key || c.key === filtersNotGroup[i].refItem).length > 0) {
						if (this.fields.filter((c: any) => c.key == filtersNotGroup[i].key || c.key === filtersNotGroup[i].refItem)[0].class.indexOf('collapse') > -1) {
							filtersNotGroup[i].selected = false;
						}
						else {
							allowFilter.push(filtersNotGroup[i]);
						}
					}
				}
			}
			return allowFilter;
		}

		getGroupFilters() {
			var allowFilter = [];
			if (this.filters != null) {
				var filtersGroup = (this.filters as Array<any>).filter(c => c.group == true && c.group != undefined);

				for (var i = 0; i < filtersGroup.length; i++) {
					allowFilter.push(filtersGroup[i]);
				}
			}
			return allowFilter;
		}

		showButtonInRow(data: any, showButton: boolean) {
			if (this.onlyShow) {
				return false;
			}
			if (data != undefined) {
				return showButton && (data as boolean) == true;
			}
			return showButton;
		}

		showButtonDelete(data: any) {
			if (this.onlyShow) {
				return false;
			}
			if (data != undefined) {
				return this.buttonDelete && (data as boolean) == true;
			}
			return this.buttonDelete;
		}

		isLoading() {
			return this.isBusy && this.isBusyShow;
		}

		showButtonUpdate(data: any) {
			if (this.onlyShow) {
				return false;
			}
			if (data != undefined) {
				return this.buttonUpdate && (data as boolean) == true;
			}
			return this.buttonUpdate;
		}

		//tady se to rozděli pomoci značky  #a#
		prepareDataColumn(data: any) {
			if (data) {
				let sData: string = String(data)
				if (sData.length > 0) {
					return sData.split('#a#');
				}
			}
			return null;
		}

		/*#region  zobrazení tagů */

		changeTags(items: any): void {
			this.$emit('changeTags', items, this.lastIdComponent);
		}

		deleteFromPopup(id: any): void {
			this.$emit('deleteFromPopup', id);
		}

		gridColor(color: string): string {
            return 'background-color: ' + color + ';'
		}
      

        showAllTaskId: Array<number> = [];
        showAllTagId: Array<number> = [];
		showAllReceiverId: Array<number> = [];
       

       

		changeShowAllTask(id: number) {
            var index = this.showAllTaskId.indexOf(id);
            if (index != -1) {
                this.showAllTaskId.splice(index);
            }
            else {
                this.showAllTaskId.push(id);
            }
		}

        showAllTask(id: number) {
            var index = this.showAllTaskId.indexOf(id);
            return index != -1;
        }
       
		showAllTags(id: number) {
			var index = this.showAllTagId.indexOf(id);
			return index != -1;
		}

		changeShowAllTags(id: number) {
			var index = this.showAllTagId.indexOf(id);
			if (index != -1) {
				this.showAllTagId.splice(index);
			}
			else {
				this.showAllTagId.push(id);
			}
            const resultWithComma: string = this.showAllTagId.join(", ");
		}
  
        showAllReceivers(id: number) {
            var index = this.showAllReceiverId.indexOf(id);
            return index != -1;
        }
        changeShowAllReceivers(id: number) {
            var index = this.showAllReceiverId.indexOf(id);
            if (index != -1) {
                this.showAllReceiverId.splice(index);
            }
            else {
                this.showAllReceiverId.push(id);
            }
		}

		getFirstFromList(data: any) {
			if (data != undefined && (data as Array<any>).length > 0) {
				return (data as Array<any>)[0];
			}
			return null;
		}
		//vrati krome prvniho zbyvajici prvky
		getAllAfterFirst(data: any) {
            var result = [];
            for (var i = 1; i < data.length; i++) {
                result.push(data[i]);
            }
            return result;
		}

		isMoreThanOne(data: any) {		
			return (data as Array<any>).length > 1;
		}

		getAllTask(data: any) {
			var result = [];
			for (var i = 1; i < data.item.taskList.length; i++) {
                result.push(data.item.taskList[i]);
			}		
			return result;
		}

		showTaskTypeImage(data: any) {
            var result = " columnBackGroundImageTaskTypeImage ";
            switch (data.item.idTaskTypeNavigationIdentifier) {
                case "ENU_CON_Task_TaskType_Common":
                    result += "iconTaskTypeCommon";
                    break;
                case "ENU_CON_Task_TaskType_Priority":
                    result += "iconTaskTypePriority";
                    break;
                case "ENU_CON_Task_TaskType_InIdleState":
                    result += "iconTaskTypeWait";
                    break;
			}          

            return result + " imageTaskTypeTable";
		}

        showTaskTypeTitleImage(data: any) {
            var result = "";
            switch (data.item.idTaskTypeNavigationIdentifier) {
				case "ENU_CON_Task_TaskType_Common":
                    result = this.$t('task.taskTypeCommon').toString();
                    break;
                case "ENU_CON_Task_TaskType_Priority":
                    result = this.$t('task.taskTypePriority').toString();
                    break;
                case "ENU_CON_Task_TaskType_InIdleState":
                    result = this.$t('task.taskTypeIdle').toString();
                    break;
            }
            return result ;
        }

        showStatusTaskColor(data: any) {
			var result = " columnBackGroundComponentStateItemColor ";
            switch (data.item.idTaskStateNavigationIdentifier) {
                case "ENU_CON_Task_TaskState_New" :
                    result += "taskStatusNew";
                    break;
                case "ENU_CON_Task_TaskState_Sent" :
                    result += "receiverStatusSent";
					break;
                case "ENU_CON_Task_TaskState_Playing":
                    result += "tastkStatePlaying";
                    break;
                case "ENU_CON_Task_TaskState_Stopped":
                    result += "taskStatusStop";
                    break;               
            }

            return result + " gridIconsReciverActive";
        }


		showActivityColor(data: any) {
            var result = " columnBackGroundComponentStateItemColor ";
            switch (data.item.idComponentStateNavigationIdentifier) {
                case "ENU_COR_Component_State_Active" :
                    result += "receiverStatusActive";
                    break;
                case "ENU_COR_Component_State_Activating":
                    result += "receiverStatusActive";
                    break;
                case "ENU_COR_Component_State_New":
                    result += "receiverStatusNew";
                    break;
                case "ENU_COR_Component_State_Provisioned":
                    result += "receiverStatusLost";
                    break;
                case "ENU_COR_Component_State_Provisioning":
                    result += "receiverStatusLost";
                    break;
                case "ENU_COR_Component_State_Lost" || "ENU_COR_Component_State_Stopping":
                    result += "receiverStatusLost";
                    break;
            }

            return result + " gridIconsReciverActive";
		}

		columnColor(color: string): string {
			return 'background-color: ' + color + ';' + ' color: ' + color + ';';
		}

		//TODO jak zjisti aktualni sirku sloupce
		getShowTags(tags: Array<any>): Array<any> {
            var result = [];
			if (tags != undefined) {
				if (tags.length > 0) {
					result.push(tags[0]);
				}
            }
            return result;
		}

        //TODO vice tagu na radku
		getShowTagsNew(tags: Array<any>): Array<any> {
			return tags;
		}
	  //zatim jen pokus
		tagClassParent(id: number) {
            return this.showAllTags(id) ? "gridTagParent" : "gridTagParent tagMaxHeight ";
		}

		idTagLast(id: any) {
			return "idTagLast" + id;
		}

		isOverflowingTag(id: any) {
			var element = document.getElementById(this.idTagLast(id));
            
			if (element == null) {
				return false;
			}
			else {
				var result = element.scrollHeight > element.clientHeight;
				return result;
			}
        }

		//TODO vice tagu na radku end

		addNewTag(item: any) {
			this.$bvModal.show('tagDialog');
			this.lastIdComponent = Number(item.id);
			(this.$refs.tagModal as TagModal).setSelected(item.tags, this.lastIdComponent, item.name);
		}

		showPopUpWindow(data: any) {
			if (this.designType(data, 'popupImage')) {

			if (data.field.action != 'notClick'){
				this.$bvModal.show('popupDialog');
				var id = Number(data.item.id);
                (this.$refs.popupModal as PopUpModal).setSelected(id, this.filterItems(), this.objectType, this.sortBy, this.sortDesc);
				(this.$refs.popupModal as PopUpModal).showLogoText(false);
			}
			}
		}

		prepareToolTipTags(data: Array<any>): string {
			var result = '<div>';
			for (var i = 0; i < data.length; i++) {
				result += data[i].name + '<br/>';
			}
			result += '</div>';
			return result;
		}

		showToolTipTag(data: Array<any>): boolean {
			let sum: number = 0;
			data.forEach(c => sum += c.name.length);
			return sum > this.maxWidthTagColumn;
		}

		/*#endregion TAGY */

		removeItem(selectedOption: any) {
			this.clickRow(selectedOption.id, false);
		}

		//zatím je výběr více řádků
		get selectMode() {
			return 'multi';
		}

		//změna jakehokoliv filtru
		changeFilter(id: any) {
			this.isBusy = true;
			this.filterItems();
			this.isBusy = false;
		}

		/**zapnuti filtru*/
		clickFilterOn(key: string) {
			var filter = (this.filters as Array<any>).filter(c => c.key == key)[0];
			filter.selected = filter.default != undefined ? true : !filter.selected;
			if (filter.selected) {
				let id = filter!.key + 'FilterInput';
                this.$nextTick(() => {
                    document.getElementById(id)!.focus();
                })
			
			}
			else {

				if (filter.group == undefined) {
					this.clearInputFilter(filter);
				}
				if (filter.type == 'multi') {
					(this.$refs.tags as Array<any>)[0].clearMultiAll();
                    //this.filter.value = '';
                    //this.filters[i].selected = false;
                }
			}
			this.setHeightTableNextTick();
			this.isBusy = false;
		}


		fieldsPlusSel: any[] = [];
		fieldsItems() {
			if (this.fieldsPlusSel.length == 0) {
				let actionField = (this.fields as Array<any>).filter(c => c.key == 'actions')[0];

				if (actionField != undefined && actionField.class == undefined) {
					actionField.class = 'width140';		 //defaultni nastaveni
					if (actionField.label == undefined) {
						actionField.label = '';
					}
				}
				if (this.selected) {
					this.fieldsPlusSel.push({ key: 'selected', label: '', sortable: false, class: 'columnSelected ', optional: false });
					for (var i = 0; i < this.fields.length; i++) {
						this.fieldsPlusSel.push(this.fields[i]);
					}
				}
				else {
					this.fieldsPlusSel = this.fields;
				}
			}
			return this.fieldsPlusSel;
		}

		//počet všechn záznamů a aktuální stránka
		//sumaryAllItemsText() {
		//	let result = this.totalRows;
		//	let start = (this.currentPage - 1) * this.perPage + 1;
		//	let end = (this.currentPage) * this.perPage;
		//	if (end > this.totalRows) {
		//		end = this.totalRows;
		//	}

		//	if (this.totalRows == 0) {
		//		return this.$t('baseTable.noRecord');
		//	}
		//	return start + '-' + end + '/' + result;
		//}


	changeMultiSelectFilter(id: string, selectMulti: any): void {
		var key = id.replace('FilterInput', '');
		(this.filterData.filter(c => c.key == key)[0]).value = selectMulti;


		//když uz nebude vybran zadny tag tak se zrusi vyber filtru - docasne zruseno
		if ((selectMulti as Array<any>).length == 0) {
			(this.filterData.filter(c => c.key == key)[0]).selected = false;
		}
	}

		//changeMultiSelectFilter(id: string, selectMulti: any): void {
		//	var key = id.replace('FilterInput', '');
		//	(this.filterData.filter(c => c.key == key)[0]).value = selectMulti;
		//	//když uz nebude vybran zadny tag tak se zrusi vyber filtru - docasne zruseno
		//	//if ((selectMulti as Array<any>).length == 0) {
		//	//	(this.filterData.filter(c => c.key == key)[0]).selected = false;
		//	//}
		//}

		//controlDown = false;
		//ctrlDownUp(isDown: boolean) {
		//	this.controlDown = isDown;
		//}

		notAllowClick = false;
		//nastaveni tagu po kliku rovnou do filtru
		tagDetail(item: any, data: any): void {
			//nedari se mi to pres css tak bohuzel takhle
			this.notAllowClick = true;
			if (data.field.action == 'filter') {
				var filterEdit = (this.filterData.filter((c: any) => c.key == 'tags')[0]);
                if (filterEdit.value != null && filterEdit.value != '') {
                    var isSelected = filterEdit.value.filter((c: any) => c.id == item.id);
                    if (isSelected.length > 0 && (filterEdit.value as Array<any>).length == 1) {
                        filterEdit.value = '';
                        filterEdit.selected = false;
					}
					else {                       
						if (filterEdit.value == null || filterEdit.value == '' || filterEdit.value == undefined) {
                            item.isOR = this.controlDown;
							filterEdit.value = [item];
							
                            (this.$refs.tags as Array<any>)[0].initMulti([item]);
						}
						else {
							var allTagsFilter = filterEdit.value as Array<any>;
                            if (allTagsFilter.some((c: any) => c.id == item.id)) {
                                allTagsFilter = allTagsFilter.filter((c: any) => c.id != item.id);
							}
							else {

                                item.isOR = this.controlDown;
                                allTagsFilter.push(item);
							}
							filterEdit.value = allTagsFilter;
                            (this.$refs.tags as Array<any>)[0].initMulti(allTagsFilter);
						}
					//	filterEdit.value = nov;
						//  filterEdit.value = [item];
						filterEdit.selected = true;
					}
				}
				else {
                    item.isOR = this.controlDown;
                    filterEdit.value = [item];
					filterEdit.selected = true;
                    (this.$refs.tags as Array<any>)[0].initMulti([item]);
				}
			}
			else {
				this.$bvModal.show('detailModal');
				(this.$refs.detailModal as ModalDetail).setSelected(item.id);
			}
		}

        //vybrani tagu do filtru z gridu
		detailTag(item: any) {
			this.selectFilterTag(item, 'tags');
		}

		selectFilterTag(item: any, key: string) {
            var filterEdit = (this.filterData.filter((c: any) => c.key == key)[0]);
            if (filterEdit.value != null && filterEdit.value != '') {
                var isSelected = filterEdit.value.filter((c: any) => c.id == item.id);
                if (isSelected.length > 0 && (filterEdit.value as Array<any>).length == 1) {
                    filterEdit.value = '';
                    filterEdit.selected = false;
                }
                else {
                    filterEdit.value = [item];
                    filterEdit.selected = true;
                }
            }
            else {
                filterEdit.value = [item];
                filterEdit.selected = true;
            }
		}

		goBackDetailTag(item: any): void {
			this.$emit('goBackDetailModal', item);
		}

		//zobrazení ikon na hlavní liste vpravo
		showIconFilters(): boolean {
			return this.getFilters().length > 0;// && !this.showFilterSetting && !this.showColumnSetting;
		}

		showIconClose(): boolean {
			const modalShow = this.showInModal == undefined ? false : this.showInModal;
			return modalShow && !this.showFilterSetting;
		}

		showIconColumnSetting(): boolean {
			return this.optionsColumns.length > 0 && !this.isGridShow;// && !this.showFilterSetting && !this.showColumnSetting;
		}

		showHideBlockFilter() {
            return this.showFilterSetting || this.showColumnSetting;
		}


		//changeVisibilityFilterSetting() {
		//	this.showFilterSetting = this.showColumnSetting = false;
  //          this.$emit('changeShowMenu', false);            
		//}

		showIconGrid(): boolean {
			return this.allowGrid == true;
		}

		showIconTable(): boolean {
			return this.allowGrid == true;
		}

		showIconSeparate(): boolean {
			return this.allowGrid == true && (this.showIconFilters() || this.showIconColumnSetting()) && (this.showIconGrid() || this.showIconTable());
		}

		changeOrderGrid(order: any) {
			super.changeOrderGrid(order);
		}

		changeOrderAscGrid(order: boolean) {
			super.changeOrderAscGrid(order);
		}

		detailClick(id: number): void {
			this.$emit('clickDetail', id);
		}

		goToLinkClick(item: any): void {
			this.$emit('linkDetail', item );
		}

        goToLinkClickItem(item: any): void {
            this.$emit('linkDetail', item);
        }

        actionDeleteId(id: any) {

            this.deselectAll(); //TODO tady domyslet jestli je to nebude nekdy vadit
            this.$emit('clickDelete', id);
        }

		actionDelete(item: any) {
			
			this.deselectAll(); //TODO tady domyslet jestli je to nebude nekdy vadit
			this.$emit('clickDelete', item.id);
            this.$emit('clickDeleteItem', item);
		}
		//když nechci jen prosté ID
		actionOther(item: any) {
			this.$emit('clickOther', item);
		}

		//když nechci jen prosté ID
		actionOther2(item: any) {
			this.$emit('clickOther2', item);
		}

		//když nechci jen prosté ID
		actionOther3(item: any) {
			this.$emit('clickOther3', item);
		}

		//když nechci jen prosté ID
		actionOther4(item: any) {
			this.$emit('clickOther4', item);
		}

		//vlastní definované tlačítko
		actionOwnButton(action: any, isSingleRow: boolean, item: any) {
			if (isSingleRow) {
				this.$emit(action, item);
			}
			else {
				this.$emit(action, this.selectedRowMain);
			}
		}

		rowDblClick(id: any) {
			this.$emit('clickRow', id);
		}

		get isModalDesign() {
			return this.design == 'modalTable';
		}

		get inputClassHead() {
			return {
				"tabMenu": this.design == '',
				"tabMenuDetail": this.design == 'detail' ||  this.design == 'detailPage',
				"tabMenuNoBorder": this.design == 'modalTable'
			};
		}

		get inputClassHeadDescription() {
			return {
                "table-description-text": true,
				"table-description-text-detail": this.design == 'detail'
			};
		}

		get inputClassHeadAddIcon() {
			return {
				"iconsAddNew": this.design == '' || this.design == 'modalTable',
				"iconsAddNewDetail": this.design == 'detail'
			};
		}


        filterItems() {
            var result = super.filterItems();
            result.sort((a: any, b: any) => {
                let aValue = a[this.sortBy];
                let bValue = b[this.sortBy];

                // Převedení hodnot na řetězce nebo zpracování null/undefined hodnot
                if (aValue == null) aValue = ''; // Převede null nebo undefined na prázdný řetězec
                if (bValue == null) bValue = ''; // Převede null nebo undefined na prázdný řetězec

                // Zajištění, že hodnoty jsou typu string před voláním localeCompare
                aValue = String(aValue);
                bValue = String(bValue);

                // Podmíněné řazení podle toho, jestli je sortDesc true nebo false
                if (this.sortDesc) {
                    return bValue.localeCompare(aValue);
                } else {
                    return aValue.localeCompare(bValue);
                }
            });

            return result;
        }



		clickRow(id: any, isClick: boolean) {
			if (this.notAllowClick) {
				this.notAllowClick = false;
				return;
			}
			super.clickRow(id, isClick);
		}

		doubleClick(item: any, index: any) {
			if (this.allowDoubleClick && this.showInModal) {
				super.doubleClickRow(item, index);
			}
		}


		contextChange() {
			super.contextChange();
		}

		headClicked(key: any) {
			var column = (this.fields as Array<any>).filter((c: any) => c.key == key)[0];
			if (column.sortable == true) {
				this.sortBy = key;
			}
		}
		
		sortChanged() {	

			super.sortChanged();
		}

		getFiltersByGroupsForShow() { 
			return super.getFiltersByGroupsForShow(); }

		useFilters() {
			return super.useFilters();
		}

		setModalTag() {
			(this.$refs.tagModal as TagModal).setModalTag(this.typeTagModal);			
		}

		prepareFilterId(item: any) {
			return "FilterId" + item;
		}

		created() {
			this.initBaseProperties();
			super.created();
		
		}

		initMulti = true;
		beforeUpdate() {
			super.beforeUpdate();
			//inicializace filtr multi
            var filterTag = (this.filterData.filter((c: any) => c.key == 'tags'));
			if (filterTag.length > 0) {
				if (filterTag[0].value != null && this.initMulti) {
					this.initMulti = false;
					var allTagsFilter = filterTag[0].value as Array<any>;
					(this.$refs.tags as Array<any>)[0].initMulti(allTagsFilter);
				}
            }
		}

		initBaseProperties() {
			this.gridFieldsBase = this.gridFields;
			this.fieldsBase = this.fields;
			this.filtersBase = this.filters;
			this.selectedBase = this.selected == null ? false : this.selected;
			this.itemsDataBase = this.itemsData;

			this.selectedMultiNamesBase = this.selectedMultiNames;
			this.nameBase = this.name == null ? '' : this.name;
			this.designBase = this.design == null ? '' : this.design;
			this.defaultSortByBase = this.defaultSortBy == null ? '' : this.defaultSortBy;
            this.defaultSortDescBase = this.defaultSortDesc == null ? false : this.defaultSortDesc;
			this.onlyOneBase = this.onlyOne == true;
		}

		initItemsData(): void {
			this.itemsDataBase = this.itemsData;
		}

		//nastaveni query které bude stále zůstavat - 
		public setQuery(query: any) {
			this.queryBase = query;
		}

   

        @Watch('itemsData')
        itemsDataChanged(value: string, oldValue: string) {
            if (value !== oldValue) {
                this.initItemsData();
                this.$forceUpdate();
            }
        }

		@Watch('fields')
		fieldsDataChanged(value: string, oldValue: string) {
			if (value !== oldValue) {
				this.fieldsBase = this.fields;
			}
		}

		@Watch('filters')
		filtersDataChanged(value: string, oldValue: string) {
			if (value !== oldValue) {
				this.filtersBase = this.filters;
			}
		}

		// #region časovač na schovávání menu filtru a setting columu
		timers: number[] = [];
		leaveFilterMenu(): void {
			var tim = setTimeout(() => {
				//TODO zpet
				//this.showFilterSetting = false;
			}, 1000);
			this.timers.push(tim);
		}

		enterFilterMenu(): void {
			this.showFilterSetting = true;
			for (var i = 0; i < this.timers.length; i++) {
				clearTimeout(this.timers[i]);
			}
			this.timers = [];
		}
		leaveSettingMenu(): void {
			var tim = setTimeout(() => {
				//TODO tady dat zpet pokud chceme aby menu mizelo
				//	this.showColumnSetting = false;
			}, 400);
			this.timers.push(tim);
		}

		enterSettingMenu(): void {
			this.showColumnSetting = true;
			for (var i = 0; i < this.timers.length; i++) {
				clearTimeout(this.timers[i]);
			}
			this.timers = [];
		}

		private goBackPage(): void {
			this.$emit('goBackPage', true);
		}

        private goBackPage2(): void {
            this.$emit('goBackPage2', true);
		}

        private goBackPage3(): void {
            this.$emit('goBackPage3', true);
		}




        nextPage() {
         

            this.countNextPageNotChangeBack = true;
			if (this.countNextPage == 1) {
                this.oldCurrentPage = this.currentPage;
				if (this.currentPage > 0) {
                    this.currentPageCount = this.currentPage;
                    this.currentPage = 1;
                }
            }

            this.countNextPage = this.countNextPage + 1;

            if ((this.perPage * this.currentPageCount) < this.totalRows) {
                this.currentPageCount = this.currentPageCount + 1;
            }

        }

		//NAVIC - je tu kvuli error hlasce v consoli (je to v BaseTLTableV2)
        @Watch('perPage')
		onPropertyChangedPerPage(value: number, oldValue: number) {              
			this.countNextPage = 1;
			this.currentPageCount = 1;
		}

        @Watch('currentPageCount')
        onPropertyChangedCurrentPageCount(value: number, oldValue: number) {          
			if (!this.countNextPageNotChangeBack) {
				this.currentPage = value;
				this.countNextPage = 1;
				this.countNextPageNotChangeBack = true;
			}
			else {        
				this.countNextPageNotChangeBack = false;
			}
        }

        @Watch('currentPage')
        onPropertyChangedCurrentPage(value: number, oldValue: number) {
			if (value !== oldValue) {				             
                //@ts-ignore
                var table = this.$refs.mainTab.$el;
                if (table != undefined) {
                    table.scrollTop = 0;
                }
            }
        }

			// #endregion
	}
